var _ellipse, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _polygon, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect3, _rect4, _path22, _circle, _circle2, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.27,
    cy: 239.7,
    rx: 168.6,
    ry: 8.99,
    fill: "#e6e6e6",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.11,139.74s5.72-5,8.6-1-.93,6.62-5.93,6.89S197.11,139.74,197.11,139.74Z",
    fill: "#f4a28c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.11,139.74s5.72-5,8.6-1-.93,6.62-5.93,6.89S197.11,139.74,197.11,139.74Z",
    opacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.35,118s5.54,23.46,20.8,24.17,32.34-6.93,32.34-6.93l3,9.4L157.68,156s-26.55-13.66-26.89-15.26S143.35,118,143.35,118Z",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.35,118s5.54,23.46,20.8,24.17,32.34-6.93,32.34-6.93l3,9.4L157.68,156s-26.55-13.66-26.89-15.26S143.35,118,143.35,118Z",
    opacity: 0.08
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 267.68,
    y: 175.7,
    width: 40.79,
    height: 23.31,
    fill: "#c1c1c1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 231.28,
    y: 155.95,
    width: 47.92,
    height: 43.06,
    fill: "#ffd200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.71,144.62h10.56a6.69,6.69,0,0,1,6.62,5.69l7.43,48.7h77.23a8.43,8.43,0,0,0,8.19-6.45L327.28,145",
    fill: "none",
    stroke: "#24285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.77,230.61s3.12,2.5,6.17,1,5.55.84,3.39,3.18-10.94,3.1-10.94,3.1l-3.39-5.3Z",
    fill: "#68e1fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.55,213.05s-4,.51-5,3.77-4.46,3.41-4.64.24,5.35-10,5.35-10l6.18,1.23Z",
    fill: "#68e1fd"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "125.05 64.34 118.23 80.58 127.72 85.91 129.13 71.34 125.05 64.34",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129,74.55a7.09,7.09,0,0,1-2.9-2.87s-.71,3.53,2.28,7.91Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.63,63.56s1,5.9.34,9.94A3,3,0,0,1,130.49,76a6.65,6.65,0,0,1-5.59-4.55l-2.22-5.07a5.37,5.37,0,0,1,1.88-5.92C127.73,57.73,133.19,59.93,133.63,63.56Z",
    fill: "#f4a28c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.17,63.93a24.47,24.47,0,0,1-5.54,0,5,5,0,0,1,.46,5.46,4.07,4.07,0,0,1-4.76,2l-.54-7.67a6.09,6.09,0,0,1,2.63-5.68,19.8,19.8,0,0,1,2.45-1.46c2.14-1.07,5.49.13,7.35-1.52a1.44,1.44,0,0,1,2.36.75c.54,2.3.42,6-2.62,7.54A5.34,5.34,0,0,1,132.17,63.93Z",
    fill: "#24285b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.71,69.2s-.23-2.3-1.95-2-1.39,3.64,1,3.76Z",
    fill: "#f4a28c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.07,67.31l1.86,2.16a1,1,0,0,1-.48,1.55l-2.24.62Z",
    fill: "#f4a28c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.62,88.11c-.57-.43-1.12-.88-1.66-1.35-3.25-2.84-15-11.94-26.94-7-14.08,5.88-7.74,13.59,4.37,14.59C143.81,97.24,136.4,90.16,133.62,88.11Z",
    fill: "#68e1fd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.62,88.11c-.57-.43-1.12-.88-1.66-1.35-3.25-2.84-15-11.94-26.94-7-14.08,5.88-7.74,13.59,4.37,14.59C143.81,97.24,136.4,90.16,133.62,88.11Z",
    fill: "#fff",
    opacity: 0.44
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.8,87.34c-13-4.9-27.68.3-35.44,11.85-3.71,5.52-7,12.33-7.78,19.78C82.64,137.81,80,154.41,80,154.41l36.65,16s30.45-21.29,29.16-46.55C144.86,106,141.67,92.55,127.8,87.34Z",
    fill: "#68e1fd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.11,97.67s-13.93,15.54-7.78,43.06-9.92,20-9.92,20l22.21,9.72s11.07-8.93,13.84-12.44l2.77-3.51Z",
    opacity: 0.08
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.78,91.76s12,2.91,13.44,18S147,149.31,165,145.67s33-6.07,33-6.07l2.91,9.71s-50.44,29.38-75.12,4.86S104.32,86.9,125.78,91.76Z",
    fill: "#68e1fd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.78,91.76s12,2.91,13.44,18S147,149.31,165,145.67s33-6.07,33-6.07l2.91,9.71s-50.44,29.38-75.12,4.86S104.32,86.9,125.78,91.76Z",
    fill: "#fff",
    opacity: 0.44
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80,154.41s-6.07,11.41,0,16,47.14,39.34,55,62.65l8.36-3.4s-7.07-33.27-26.73-59.25Z",
    fill: "#24285b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80,170.44s31.32,43.46-19.67,34.48v9s51.45,13.85,50-18S80,170.44,80,170.44Z",
    fill: "#24285b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91,142.69s7.74-4.51,9.68,0-7.69,6.62-7.69,6.62Z",
    fill: "#f4a28c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 253.35,
    y: 135.22,
    width: 25.85,
    height: 20.72,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 278.27,
    y: 146.56,
    width: 30.2,
    height: 29.14,
    fill: "#e6e6e6",
    opacity: 0.43
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.92,189.87l4,24.8a10.63,10.63,0,0,0,10.49,8.93h68.66",
    fill: "none",
    stroke: "#24285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 246.94,
    cy: 232.52,
    r: 5.7,
    fill: "#68e1fd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.77,
    cy: 232.52,
    r: 5.7,
    fill: "#68e1fd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 249.94,
    y: 155.95,
    width: 9.45,
    height: 13.98,
    fill: "#fff",
    opacity: 0.61
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.42b490dabf8131de98fe6faa53b0863b.svg";
export { ForwardRef as ReactComponent };